import type { Directive } from 'vue'

import { prefersReducedMotion } from '@/utils/onEnter'

interface TiltHandlers {
  move: (event: MouseEvent) => void
  leave: () => void
}

interface TiltElement extends HTMLElement {
  _tilt?: TiltHandlers
}

/**
 * Директива 3D-наклона по курсору. Значение — максимальный угол в градусах
 * (по умолчанию 10). Отключается при prefers-reduced-motion.
 *
 * @example <div v-tilt="6" />
 */
export const vTilt: Directive<TiltElement, number | undefined> = {
  mounted(el, binding) {
    const max = binding.value ?? 10
    el.style.transition = 'transform .25s ease'
    el.style.transformStyle = 'preserve-3d'
    if (prefersReducedMotion()) return

    const move = (event: MouseEvent): void => {
      const rect = el.getBoundingClientRect()
      const px = (event.clientX - rect.left) / rect.width - 0.5
      const py = (event.clientY - rect.top) / rect.height - 0.5
      el.style.transform = `perspective(900px) rotateX(${(-py * max).toFixed(2)}deg) rotateY(${(px * max).toFixed(2)}deg) translateZ(0)`
    }
    const leave = (): void => {
      el.style.transform = ''
    }

    el.addEventListener('mousemove', move)
    el.addEventListener('mouseleave', leave)
    el._tilt = { move, leave }
  },
  unmounted(el) {
    if (el._tilt === undefined) return
    el.removeEventListener('mousemove', el._tilt.move)
    el.removeEventListener('mouseleave', el._tilt.leave)
  },
}
